module.exports = __webpack_public_path__ + "img/icon_top.7ad91879.png";